import React, { useState, useEffect } from "react";
import reference from "../reference";
import axios from "axios";
import { baseURL } from "../../../Redux/baseURL";
import { ToastContainer, toast } from 'react-toastify';
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

function EmployerProfileHeaderOfficial({HandleUpdate}) {
  const navigate = useNavigate();
  // Tolu
  const employer = useSelector((e) => e.employer);
  const profile = employer.message;
  const userPics = useSelector((prev) => prev.userInfo);
  const [picLink, setPicsLink] = useState("");
  //   BigSam
  // useEffect(() => {
  //   let token = localStorage.getItem("token");

  //   const headers = {
  //     Authorization: `Bearer ${token}`,
  //   };

  //   axios
  //     .get(baseURL + "/api/employer/my_employee_profile", { headers })
  //     .then((resp) => {
  //       console.log(resp);
  //       if (resp.data.success === true) {
  //         setImageuri(resp.data.data.imageuri);
  //         console.log("imageuri", imageuri);
  //       }
  //     });
  // }, []);

  useEffect(() => {
    if (userPics.user !== null) {
      setPicsLink(userPics.user.profile_pics);
    }
  }, [userPics]);

  const handleClick = () => {
    setTimeout(() => {
      toast.error("You cannot create a job post yet.", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }, 50);
  };

  const handleAppView = () => {
    setTimeout(() => {
      toast.error("No Appicant yet.", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }, 50);
  };

  function handleChangePP() {
      navigate("/user/update/profilephoto");
  }

  return (
    <div className="w-full py-16 bg-[#EFECFF] tablet:rounded-t-2xl flex justify-between px-[2%] tablet:px-[10%]">
      {/* div for profile LHS */}
      <div className="flex flex-col tablet:flex-row items-center min-h-[10rem] gap-4 tablet:gap-9">
        {/* profile photo  */}
        {profile?.photo !== undefined ? (
          <div className="relative h-20 w-20 tablet:h-40 tablet:w-40 rounded-full">
            <img
              src={profile?.photo}
              alt=""
              className="rounded-full h-20 w-20 tablet:h-40 tablet:w-40"
            />
            <div onClick={handleChangePP} className="absolute top-0 right-[0%]">
              <svg
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.666 10.9999C19.4008 10.9999 19.1464 11.1053 18.9589 11.2928C18.7714 11.4804 18.666 11.7347 18.666 11.9999V17.9999C18.666 18.2652 18.5607 18.5195 18.3731 18.707C18.1856 18.8946 17.9312 18.9999 17.666 18.9999H3.66602C3.4008 18.9999 3.14645 18.8946 2.95891 18.707C2.77137 18.5195 2.66602 18.2652 2.66602 17.9999V3.99994C2.66602 3.73472 2.77137 3.48037 2.95891 3.29283C3.14645 3.1053 3.4008 2.99994 3.66602 2.99994H9.66602C9.93123 2.99994 10.1856 2.89458 10.3731 2.70705C10.5607 2.51951 10.666 2.26516 10.666 1.99994C10.666 1.73472 10.5607 1.48037 10.3731 1.29283C10.1856 1.1053 9.93123 0.999939 9.66602 0.999939H3.66602C2.87037 0.999939 2.1073 1.31601 1.5447 1.87862C0.982086 2.44123 0.666016 3.20429 0.666016 3.99994V17.9999C0.666016 18.7956 0.982086 19.5587 1.5447 20.1213C2.1073 20.6839 2.87037 20.9999 3.66602 20.9999H17.666C18.4617 20.9999 19.2247 20.6839 19.7873 20.1213C20.3499 19.5587 20.666 18.7956 20.666 17.9999V11.9999C20.666 11.7347 20.5607 11.4804 20.3731 11.2928C20.1856 11.1053 19.9312 10.9999 19.666 10.9999ZM4.66602 11.7599V15.9999C4.66602 16.2652 4.77137 16.5195 4.95891 16.707C5.14645 16.8946 5.4008 16.9999 5.66602 16.9999H9.90602C10.0376 17.0007 10.1681 16.9755 10.2899 16.9257C10.4118 16.8759 10.5226 16.8026 10.616 16.7099L17.536 9.77994L20.376 6.99994C20.4697 6.90698 20.5441 6.79637 20.5949 6.67452C20.6457 6.55266 20.6718 6.42195 20.6718 6.28994C20.6718 6.15793 20.6457 6.02722 20.5949 5.90536C20.5441 5.7835 20.4697 5.6729 20.376 5.57994L16.136 1.28994C16.0431 1.19621 15.9325 1.12182 15.8106 1.07105C15.6887 1.02028 15.558 0.994141 15.426 0.994141C15.294 0.994141 15.1633 1.02028 15.0414 1.07105C14.9196 1.12182 14.809 1.19621 14.716 1.28994L11.896 4.11994L4.95602 11.0499C4.86333 11.1434 4.79001 11.2542 4.74024 11.376C4.69048 11.4979 4.66525 11.6283 4.66602 11.7599ZM15.426 3.40994L18.256 6.23994L16.836 7.65994L14.006 4.82994L15.426 3.40994ZM6.66602 12.1699L12.596 6.23994L15.426 9.06994L9.49602 14.9999H6.66602V12.1699Z"
                  fill="#FF6633"
                />
              </svg>
            </div>
          </div>
        ) : (
          <div className="relative h-20 w-20 tablet:h-40 tablet:w-40 rounded-full">
            <img
              src={picLink === "" ? reference.profilephoto1 : picLink}
              alt=""
              className="rounded-full h-20 w-20 tablet:h-40 tablet:w-40"
            />
            <div onClick={handleChangePP} className="absolute top-0 right-[0%]">
              <svg
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.666 10.9999C19.4008 10.9999 19.1464 11.1053 18.9589 11.2928C18.7714 11.4804 18.666 11.7347 18.666 11.9999V17.9999C18.666 18.2652 18.5607 18.5195 18.3731 18.707C18.1856 18.8946 17.9312 18.9999 17.666 18.9999H3.66602C3.4008 18.9999 3.14645 18.8946 2.95891 18.707C2.77137 18.5195 2.66602 18.2652 2.66602 17.9999V3.99994C2.66602 3.73472 2.77137 3.48037 2.95891 3.29283C3.14645 3.1053 3.4008 2.99994 3.66602 2.99994H9.66602C9.93123 2.99994 10.1856 2.89458 10.3731 2.70705C10.5607 2.51951 10.666 2.26516 10.666 1.99994C10.666 1.73472 10.5607 1.48037 10.3731 1.29283C10.1856 1.1053 9.93123 0.999939 9.66602 0.999939H3.66602C2.87037 0.999939 2.1073 1.31601 1.5447 1.87862C0.982086 2.44123 0.666016 3.20429 0.666016 3.99994V17.9999C0.666016 18.7956 0.982086 19.5587 1.5447 20.1213C2.1073 20.6839 2.87037 20.9999 3.66602 20.9999H17.666C18.4617 20.9999 19.2247 20.6839 19.7873 20.1213C20.3499 19.5587 20.666 18.7956 20.666 17.9999V11.9999C20.666 11.7347 20.5607 11.4804 20.3731 11.2928C20.1856 11.1053 19.9312 10.9999 19.666 10.9999ZM4.66602 11.7599V15.9999C4.66602 16.2652 4.77137 16.5195 4.95891 16.707C5.14645 16.8946 5.4008 16.9999 5.66602 16.9999H9.90602C10.0376 17.0007 10.1681 16.9755 10.2899 16.9257C10.4118 16.8759 10.5226 16.8026 10.616 16.7099L17.536 9.77994L20.376 6.99994C20.4697 6.90698 20.5441 6.79637 20.5949 6.67452C20.6457 6.55266 20.6718 6.42195 20.6718 6.28994C20.6718 6.15793 20.6457 6.02722 20.5949 5.90536C20.5441 5.7835 20.4697 5.6729 20.376 5.57994L16.136 1.28994C16.0431 1.19621 15.9325 1.12182 15.8106 1.07105C15.6887 1.02028 15.558 0.994141 15.426 0.994141C15.294 0.994141 15.1633 1.02028 15.0414 1.07105C14.9196 1.12182 14.809 1.19621 14.716 1.28994L11.896 4.11994L4.95602 11.0499C4.86333 11.1434 4.79001 11.2542 4.74024 11.376C4.69048 11.4979 4.66525 11.6283 4.66602 11.7599ZM15.426 3.40994L18.256 6.23994L16.836 7.65994L14.006 4.82994L15.426 3.40994ZM6.66602 12.1699L12.596 6.23994L15.426 9.06994L9.49602 14.9999H6.66602V12.1699Z"
                  fill="#FF6633"
                />
              </svg>
            </div>
          </div>
        )}
        <div className="h-full grid content-between ">
          {/* text content here  */}
          <div className=" text-center tablet:text-start">
            <h2 className=" font-semibold tablet:text-2xl text-lg">
              {profile?.name}
            </h2>
            <p className="font-semibold text-base text-[#898989]">
              {profile?.type_of_business}
            </p>
            {/* container for stars and the rest  */}
            {/* <div className=" tablet:flex gap-2">
              <img src={refrence.fivestars} alt="" />
              <p className="font-medium text-xs">
                5.0{" "}
                <span className=" font-normal text-[#5843BD]">
                  (See all 25 reviews)
                </span>
              </p>
            </div> */}
          </div>
          {/* buttons  */}
          <div className=" mt-4 tablet:mt-0 font-semibold text-base tablet:justify-between flex-col tablet:flex-row flex gap-2 tablet:gap-6">
            <button
              className=" bg-[#5843BD] border border-[#5843BD] hover:text-[#5843BD] hover:bg-[#E1DCF9] px-5 py-3 rounded-full text-[#ffffff] whitespace-nowrap"
              onClick={handleClick}
            >
              Create Job
            </button>
            <button
              className=" bg-[#E1DCF9] border border-[#5843BD] hover:text-[#ffffff] hover:bg-[#5843BD] hover:border-[#ffffff] px-5 py-3 rounded-full text-[#5843BD] whitespace-nowrap"
              onClick={handleAppView}
            >
              View Applications
            </button>
          </div>
        </div>
      </div>

      {/* edit icon RHS */}
      <div onClick={HandleUpdate}>
        <svg
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.666 10.9999C19.4008 10.9999 19.1464 11.1053 18.9589 11.2928C18.7714 11.4804 18.666 11.7347 18.666 11.9999V17.9999C18.666 18.2652 18.5607 18.5195 18.3731 18.707C18.1856 18.8946 17.9312 18.9999 17.666 18.9999H3.66602C3.4008 18.9999 3.14645 18.8946 2.95891 18.707C2.77137 18.5195 2.66602 18.2652 2.66602 17.9999V3.99994C2.66602 3.73472 2.77137 3.48037 2.95891 3.29283C3.14645 3.1053 3.4008 2.99994 3.66602 2.99994H9.66602C9.93123 2.99994 10.1856 2.89458 10.3731 2.70705C10.5607 2.51951 10.666 2.26516 10.666 1.99994C10.666 1.73472 10.5607 1.48037 10.3731 1.29283C10.1856 1.1053 9.93123 0.999939 9.66602 0.999939H3.66602C2.87037 0.999939 2.1073 1.31601 1.5447 1.87862C0.982086 2.44123 0.666016 3.20429 0.666016 3.99994V17.9999C0.666016 18.7956 0.982086 19.5587 1.5447 20.1213C2.1073 20.6839 2.87037 20.9999 3.66602 20.9999H17.666C18.4617 20.9999 19.2247 20.6839 19.7873 20.1213C20.3499 19.5587 20.666 18.7956 20.666 17.9999V11.9999C20.666 11.7347 20.5607 11.4804 20.3731 11.2928C20.1856 11.1053 19.9312 10.9999 19.666 10.9999ZM4.66602 11.7599V15.9999C4.66602 16.2652 4.77137 16.5195 4.95891 16.707C5.14645 16.8946 5.4008 16.9999 5.66602 16.9999H9.90602C10.0376 17.0007 10.1681 16.9755 10.2899 16.9257C10.4118 16.8759 10.5226 16.8026 10.616 16.7099L17.536 9.77994L20.376 6.99994C20.4697 6.90698 20.5441 6.79637 20.5949 6.67452C20.6457 6.55266 20.6718 6.42195 20.6718 6.28994C20.6718 6.15793 20.6457 6.02722 20.5949 5.90536C20.5441 5.7835 20.4697 5.6729 20.376 5.57994L16.136 1.28994C16.0431 1.19621 15.9325 1.12182 15.8106 1.07105C15.6887 1.02028 15.558 0.994141 15.426 0.994141C15.294 0.994141 15.1633 1.02028 15.0414 1.07105C14.9196 1.12182 14.809 1.19621 14.716 1.28994L11.896 4.11994L4.95602 11.0499C4.86333 11.1434 4.79001 11.2542 4.74024 11.376C4.69048 11.4979 4.66525 11.6283 4.66602 11.7599ZM15.426 3.40994L18.256 6.23994L16.836 7.65994L14.006 4.82994L15.426 3.40994ZM6.66602 12.1699L12.596 6.23994L15.426 9.06994L9.49602 14.9999H6.66602V12.1699Z"
            fill="#FF6633"
          />
        </svg>
      </div>
      <ToastContainer />
    </div>
  );
}

export default EmployerProfileHeaderOfficial;
